var $filterCheckboxes = $('.product-form__input input[type="checkbox"]');
let arryId = [];
function totalPrice() {
  var total_price = 0;
  $(".block_main_variant.active").each(function (i) {
    var $this = $(this);
    var single_total_price = parseInt($this.attr("data-total-price"));
    total_price = total_price + single_total_price;
  });

  $(".block__collection-wholesale-total-all-stocks-price_inner").html(
    Shopify.formatMoney(total_price)
  );
  if(total_price != 0){
        $(".add_to_cart_btn_inner").removeClass("button_disbled")
  }else{
    $(".add_to_cart_btn_inner").addClass("button_disbled")
  }
}
var filterFunc = function () {
  arryId = [];
  total_price = 0;
  var selectedFilters = {};
  $filterCheckboxes.filter(":checked").each(function () {
    if (!selectedFilters.hasOwnProperty(this.name)) {
      selectedFilters[this.name] = [];
    }
    selectedFilters[this.name].push(this.value);
  });
  var $filteredResults = $(".block_main_variant");
  $.each(selectedFilters, function (name, filterValues) {
    $filteredResults = $filteredResults.filter(function () {
      var matched = false,
        currentFilterValues = $(this).data("category").split(" / ");
      $.each(currentFilterValues, function (_, currentFilterValue) {
        if ($.inArray(currentFilterValue, filterValues) != -1) {
          matched = true;
          return false;
        }
      });
      return matched;
    });
  });

  if ($('.product-form__input input[type="checkbox"]').is(":checked")) {
    $(".block_last_select").removeClass("hidden");
    $(".block_main_variant").hide().filter($filteredResults).show();
    $(".block_main_variant_2").addClass("block_main_variant");
    $(".block_main_variant").removeClass("active").filter($filteredResults).addClass("active");
    $(".block_one_select").parents(".product__info-container").find(".block_hidden_filed").removeClass("hidden");
  } else {
    $(".block_last_select").addClass("hidden");
    $(".block_main_variant").hide();
    $(".block_main_variant").removeClass("active");
    $(".block_one_select")
      .parents(".product__info-container")
      .find(".block_hidden_filed")
      .addClass("hidden");
  }
  $(".block_main_variant.active").each(function () {
    arryId.push($(this).attr("data-id"));
  });
  


  if ($(window).width() < 767) {
    $(".block_vareint_data.desktop-v").each(function () {
      $(this).find(".block_main_variant").remove();
    });
  } else {
    $(".block_vareint_data.mobile-v").each(function () {
      $(this).find(".block_main_variant").remove();
    });
  }
   totalPrice();
};

$(".block_last_select").click(function () {
  if ($('.block_last_select input[type="checkbox"]').is(":checked")) {
    $(".block_hidden_filed").removeClass("hidden");
  } else {
    $(".block_hidden_filed").addClass("hidden");
  }
});

$filterCheckboxes.on("change", filterFunc);

  $(document).on("change" , ".block_qty_input input.js-qty__num" , function(){
    
 let count = $(this).val();
       $(this).parents(".block_main_variant").attr("data-qty", count);
    let totalCountprice = count * $(this).parents(".block_main_variant").attr("data-price");
    $(this).parents(".block_main_variant").attr("data-total-price", totalCountprice);
    $(this)
      .parents(".block_main_variant")
      .find(".block_varient_price")
      .html(Shopify.formatMoney(totalCountprice));
    totalPrice();
  })


  $(document).on("click", ".block_delete_btn", function () {
    arryId = [];
    $(this).parents(".block_main_variant").slideUp();
    $(this).parents(".block_main_variant").removeClass("active");
    $(this).parents(".block_main_variant").addClass("block_main_variant_2");
    $(this).parents(".block_main_variant").removeClass("block_main_variant");
    $(".block_main_variant.active").each(function () {
      arryId.push($(this).attr("data-id"));
    });
    totalPrice();
    let sizeShow = $(this).parents(".block_cm_class").attr("data-size");
    if ($(this).parents(".block_vareint_data").find(`.block_cm_class[data-size ='${sizeShow}'].active`).length == 0) {   
        $(`.size-option[data-val = '${sizeShow}'] input[data-val = '${sizeShow}']`).trigger("click"); 
    }
  });


$(document).ready(function () {


  $(document).on("click", ".js-qty__adjust--minus", function () {
    var $input = $(this).parents(".block_qty_input").find(".js-qty__num");
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    $(this).parents(".block_main_variant").attr("data-qty", count);
    let totalCountprice =
      count * $(this).parents(".block_main_variant").attr("data-price");
    $(this)
      .parents(".block_main_variant")
      .attr("data-total-price", totalCountprice);
    $(this)
      .parents(".block_main_variant")
      .find(".block_varient_price")
      .html(Shopify.formatMoney(totalCountprice));
    totalPrice();
    return false;
  });
  $(document).on("click", ".js-qty__adjust--plus", function () {
    var $input = $(this).parents(".block_qty_input").find(".js-qty__num");
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    $(this)
      .parents(".block_main_variant")
      .attr("data-qty", parseInt($input.val()));
    let totalCountprice =
      parseInt($input.val()) *
      $(this).parents(".block_main_variant").attr("data-price");
    $(this)
      .parents(".block_main_variant")
      .attr("data-total-price", totalCountprice);
    $(this)
      .parents(".block_main_variant")
      .find(".block_varient_price")
      .html(Shopify.formatMoney(totalCountprice));
    totalPrice();

    return false;
  });

  const $sample_atc_submit_event = async function ($form_data) {
    const $sample_addtocart_result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify($form_data),
    });
    const $atc_success_result = await $sample_addtocart_result.json();

    if ($atc_success_result.items) {
      if (
        document.querySelector("cart-drawer") &&
        document.querySelector("cart-drawer").classList.contains("is-empty")
      )
        document.querySelector("cart-drawer").classList.remove("is-empty");
      const quickAddModal = document.querySelector("quick-add-modal");
      if (quickAddModal) {
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              document
                .querySelector("cart-drawer")
                .renderContents($atc_success_result);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        if ($("body").hasClass("block_cart_drawer")) {
          document
            .querySelector("cart-drawer")
            .renderContents($atc_success_result);
        } else {
          window.location.href = "/cart";
        }
      }
    } else {
      console.error($atc_success_result);
    }
  };
  $(document).on("click", ".add_to_cart_btn_inner", function (e) {


if ($(this).parents(".custom-product__info").find('.custom-field-input').length) {
if ($(this).parents(".custom-product__info").find('.custom-field-input').val().length === 0) {

 
    var customProductInfo = $(this).parents(".custom-product__info");
    var customFieldWrapper = customProductInfo.find('.custom-field-wrapper');
    customFieldWrapper.find('.warning').remove();
    customFieldWrapper.append(`<p class="warning">This field is required*</p>`);
    $(this).parents(".custom-product__info").find('.custom-field-input').blur(function () {
        if ($(this).val().length === 0) {
            customFieldWrapper.find('.warning').remove();
            customFieldWrapper.append(`<p class="warning">This field is required*</p>`);
        }
    });
}

 else{
   var customProductInfo = $(this).parents(".custom-product__info");
    var customFieldWrapper = customProductInfo.find('.custom-field-wrapper');
    customFieldWrapper.find('.warning').remove();
    e.preventDefault(), e.stopImmediatePropagation();
    let sample_product_atc_array = [];
    $(".block_main_variant.active").each(function () {
      sample_product_atc_array.push({
        id: $(this).attr("data-id"),
        quantity: $(this).attr("data-qty"),
        properties:{
          "PERSONALIZED NAME":$(this).parents(".custom-product__info").find('.custom-field-input').val(),
        }
      });
    });
    let sample_product_atc_formData;
    if ($("body").hasClass("block_cart_drawer")) {
      sample_product_atc_formData = {
        items: sample_product_atc_array,
        sections_url: window.location.pathname,
        sections: document
          .querySelector("cart-drawer")
          .getSectionsToRender()
          .map((section) => section.id),
      };
    } else {
      sample_product_atc_formData = { items: sample_product_atc_array };
    }

    $sample_atc_submit_event(sample_product_atc_formData);
    }

}
 else{
    e.preventDefault(), e.stopImmediatePropagation();
    let sample_product_atc_array = [];
    $(".block_main_variant.active").each(function () {
      sample_product_atc_array.push({
        id: $(this).attr("data-id"),
        quantity: $(this).attr("data-qty"),
        properties:{
          "PERSONALIZED NAME":$(this).parents(".custom-product__info").find('.custom-field-input').val(),
        }
      });
    });
    let sample_product_atc_formData;
    if ($("body").hasClass("block_cart_drawer")) {
      sample_product_atc_formData = {
        items: sample_product_atc_array,
        sections_url: window.location.pathname,
        sections: document
          .querySelector("cart-drawer")
          .getSectionsToRender()
          .map((section) => section.id),
      };
    } else {
      sample_product_atc_formData = { items: sample_product_atc_array };
    }

    $sample_atc_submit_event(sample_product_atc_formData);
    }
  });

});
